// extracted by mini-css-extract-plugin
export default {"extensionUpsellAsset":"ExtensionUpsell_extensionUpsellAsset__Lf5j-","extensionUpsellContainer":"ExtensionUpsell_extensionUpsellContainer__W05ou"};